import DashCensoEscolar from "@/Pages/CensoEscolar/index.vue";
import ShowCensoEscolar from "@/Pages/CensoEscolar/ShowCensoEscolarPage.vue";
import ShowEtapa from "@/Pages/CensoEscolar/ShowEtapaPage.vue";
import PreenchimentoCenso from "@/Pages/CensoEscolar/PreenchimentoCensoPage.vue";

export default [
  {
    path: "/censo-escolar/",
    name: "censo-escolar",
    component: DashCensoEscolar,
  },
  {
    path: "/censo-escolar/preenchimento",
    name: "censo-escolar.preenchimento",
    component: PreenchimentoCenso,
  },
  {
    path: "/censo-escolar/:id",
    name: "censo-escolar-show",
    component: ShowCensoEscolar,
  },
  {
    path: "/censo-escolar/:id/etapas/:etapaId",
    name: "censo-escolar-etapa",
    component: ShowEtapa,
  },
];
